<template>
  <div class="modal fade" id="show_item" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ title }}</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div class="d-flex flex-wrap gap-3">
            <div
              v-for="(file, index) in document_files"
              :key="index"
              class="file-preview text-center"
            >
              <div class="preview-box">
                <!-- Show image if it's an image file -->
                <img
                  v-if="isImage(file)"
                  :src="file?.preview"
                  alt="File Preview"
                  class="img-thumbnail"
                />

                <!-- Show static preview for Word or PDF -->
                <img
                  v-else-if="isPdf(file)"
                  src="@/assets/img/pdf-icon.jpg"
                  alt="PDF File"
                  class="static-thumbnail"
                />
                <img
                  v-else-if="isWord(file)"
                  src="@/assets/img/word-icon.jpg"
                  alt="Word File"
                  class="static-thumbnail"
                />
                <img
                  v-else-if="isExcel(file)"
                  src="@/assets/img/excel-icon.jpg"
                  alt="Excel File"
                  class="static-thumbnail"
                />

                <!-- Show file name if it's not an image, Word, or PDF -->
              </div>
              <div class="file-name">
                {{ getFileName(file.file_path) }}
              </div>
              <!-- File download button -->
              <button
                class="btn btn-primary btn-sm mt-2 p-0"
                @click="downloadFile(file?.file_path, index)"
                :disabled="file.loading"
              >
                {{ file.loading ? "Downloading..." : "Download" }}
                <span
                  v-if="file.loading"
                  class="spinner-border spinner-border-sm ms-2"
                ></span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from "@/utils/http";

export default {
  props: {
    isEditMode: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
  },
  data: () => ({
    isLoading: false,
    document_files: [],
    itemId: null,
    errors: {},
  }),
  mounted() {
    this.$emitter.on("show-item", (row) => {
      if (row) {
        this.itemId = row.id;
        this.fetchExistingFiles(row);
      }
      this.$handleModal("show_item", "toggle");
    });
  },
  methods: {
    fetchExistingFiles(row) {
      console.log("row files", row);
      row.files.forEach((file) => {
        this.document_files.push({
          file: file.base64,
          preview: file.base64,
          file_path: file?.file_path,
          full_url: file?.full_url,
          isExisting: true,
          loading: false,
        });
      });
    },

    isImage(file) {
      const imageExtensions = [".jpg", ".jpeg", ".png",".webp", ".gif", ".bmp", ".svg"];
      const fileExtension = file.file_path.split(".").pop().toLowerCase();
      return imageExtensions.includes(`.${fileExtension}`);
    },

    isPdf(file) {
      return this.getFileExtension(file.file_path) === "pdf";
    },

    isWord(file) {
      const wordExtensions = ["doc", "docx"];
      return wordExtensions.includes(this.getFileExtension(file.file_path));
    },
    isExcel(file) {
      const excelExtensions = ["xls", "xlsx"];
      return excelExtensions.includes(this.getFileExtension(file.file_path));
    },

    getFileExtension(filePath) {
      return filePath.split(".").pop().toLowerCase();
    },

    getFileName(filePath) {
      return filePath.split("/").pop().split(".")[0];
    },

    async downloadFile(filePath, index) {
      this.document_files[index].loading = true;
      const encodedFilePath = encodeURIComponent(filePath);
      const endpoint = `/document-download-file/${encodedFilePath}`;

      try {
        const response = await http.get(endpoint, { responseType: "blob" });
        const blob = new Blob([response.data], {
          type: response.headers["content-type"],
        });

        const blobUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = filePath.split("/").pop();

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);

        this.$toast.success("File downloaded successfully.");
      } catch (error) {
        console.error("Error downloading file:", error);
        this.$toast.error("Failed to download file.");
      } finally {
        this.document_files[index].loading = false;
      }
    },
  },
};
</script>

<style scoped>
.d-flex.flex-wrap.gap-3 {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  justify-content: center;
}

.file-preview {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  max-width: 150px;
  word-wrap: break-word;
}

.preview-box {
  height: 80px;
  width: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f8f9fa;
  border: 1px solid #ddd;
  border-radius: 5px;
  overflow: hidden;
  position: relative;
}

.img-thumbnail {
  object-fit: contain;
  max-width: 100%;
  max-height: 100%;
  height: 100% !important;
  width: 100% !important;
}

.static-thumbnail {
  max-width: 60px;
  max-height: 60px;
}

.file-name {
  font-size: 0.675rem;
  color: #333;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 100px;
  text-align: center;
}

.btn-primary.btn-sm {
  width: 100%;
  text-transform: uppercase;
  font-size: 0.7rem;
  padding: 0.5rem;
}
</style>
